// extracted by mini-css-extract-plugin
export default {"news":"LatestNewsPage_news__Q9fGJ","container":"LatestNewsPage_container__x0tOG"};